module.exports = __webpack_public_path__ + "img/flower_leaf_4.edb35c5d.png";